import { jsxs as a, jsx as l } from "react/jsx-runtime";
import { Icon as o } from "../Icon/Icon.js";
const c = "RefundableLabel-module_container__DGhTt",
  s = "RefundableLabel-module_label__f0a-p",
  i = "RefundableLabel-module_icon__7S49i",
  e = {
    container: c,
    label: s,
    icon: i
  },
  d = _ref => {
    let {
      refundabilityLabel: n
    } = _ref;
    return n === null ? null : /* @__PURE__ */a("div", {
      className: e.container,
      children: [/* @__PURE__ */l(o, {
        name: "verified_user",
        className: e.icon,
        padding: !1
      }), /* @__PURE__ */l("div", {
        className: e.label,
        children: n
      })]
    });
  };
export { d as RefundableLabel };